import { Table, Modal, message, Button, Space, Tag } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useMemo } from "react";
import service from "../../../../@services";
import AuthComponent from "../../../../components/AuthComponent";
export default ({
  dataSource,
  rowSelection,
  loading,
  editPackage,
  handleTableChange
}) => {
  const disablePackage = async (unitId) => {
    await service.package.disablePackage(unitId)
    message.success('操作成功');
    handleTableChange()
  };
  const enablePackage = async (unitId) => {
    await service.package.enablePackage(unitId)
    message.success('操作成功');
    handleTableChange()
  };
  const deletePackage = async (unitId) => {
    Modal.confirm({
      title: '提示',
      icon: <ExclamationCircleOutlined />,
      content: '确认要删除吗？',
      okText: '确认',
      cancelText: '取消',
      onOk: async ()=>{
        await service.package.deletePackage(unitId)
        message.success('操作成功');
        handleTableChange()
      }
    });
  };
  const columns = [
    { title: '序号', dataIndex: '', key: 'index', render: (text,record,index)=> index+1 },
    { title: '单位编号', dataIndex: 'id', key: 'id' },
    { title: '单位名称', dataIndex: 'name', key: 'name' },
    { title: '状态', dataIndex: 'status', key: 'status', render: (status)=> (
        status === 1
        ?<Tag color="#87d068">已启用</Tag>
        :<Tag  color="#f50">已禁用</Tag>
      )
    },
    { title: '创建时间', dataIndex: 'createTime', key: 'createTime' },
    {
      title: '操作',
      width: '220px',
      dataIndex: '',
      key: 'x',
      render: (text,record,index) => (
        <Space>
          <AuthComponent authKey="/package-unit/update">
            <Button type="link" onClick={()=>editPackage(record)}>编辑</Button>
          </AuthComponent>
          {
            record.status === 1?
            <AuthComponent authKey="/package-unit/disable/{unitId}">
              <Button type="link" onClick={()=>disablePackage(record.id)}>禁用</Button>
            </AuthComponent>:
            <>
              <AuthComponent authKey="/package-unit/enable/{unitId}">
                <Button type="link" onClick={()=>enablePackage(record.id)}>启用</Button>
              </AuthComponent>
              <AuthComponent authKey="/package-unit/delete/{unitId}">
                <Button type="link" onClick={()=>deletePackage(record.id)}>删除</Button>
              </AuthComponent>
            </>
          }
        </Space>
      ),
    },
  ];
  const { list, pageIndex, total, pageSize } = useMemo(() => {
    return {
      list: dataSource.result || [],
      pageIndex: dataSource.pageIndex || 1,
      total: dataSource.recordCount || 0,
      pageSize: dataSource.pageSize || 10
    }
  }, [dataSource])
  return (
    <Table
      rowKey={record=>record.code}
      dataSource={list}
      loading={loading}
      pagination={{
        showSizeChanger: true,
        showQuickJumper: true,
        position: ['bottomLeft'],
        current: pageIndex,
        pageSize: pageSize,
        total: total,
      }}
      columns={columns}
      onChange={(pagination)=>handleTableChange({
        pageIndex: pagination.current,
        pageSize: pagination.pageSize
      })}
    />
  )
}